var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgNi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
  fill: "#338af3"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M256 214.447c-22.949 0-41.553 18.603-41.553 41.553S233.05 297.553 256 297.553c22.949 0 41.553-18.603 41.553-41.553S278.949 214.447 256 214.447zm0 65.298c-13.114 0-23.745-10.631-23.745-23.745s10.631-23.745 23.745-23.745 23.745 10.631 23.745 23.745-10.631 23.745-23.745 23.745z",
  fill: "#ffda44"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M276.563 261.936L256 256l-20.563 5.936-6.855 11.873h54.836z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#338af3",
  d: "M256 226.32l-13.709 23.744L256 256l13.709-5.936z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M235.437 261.936h41.126l-6.854-11.872h-27.418z"
})));

export default SvgNi;